import type { FaireProductEntity } from "../../entity_types/product";

export const p_9et9q4ofbo: FaireProductEntity = {
  token: "p_9et9q4ofbo",
  type: "product",
  name: "Amethyst Kitty Face, Crystal Cat",
  brandToken: "b_en1yij2pf6",
  brandName: "Natures Artifacts Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/0cbc7a196da879df10c6cef477509c4cbd952f09e682220914eb509d4a1775a3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ef6f1d7b98253c7862dc9cd5473058e6713fd7f01b9ca6ebefb701114b470536.jpeg",
    "https://cdn.faire.com/fastly/e834d81fb6013a7147de64df0cab9f60886707892a01dc6153f14d975e34bf6c.jpeg",
    "https://cdn.faire.com/fastly/8377d3ff35d2a40127e2a5dee4b1f8faf2a713212c25d70e617de71eac5a343f.jpeg",
    "https://cdn.faire.com/fastly/a062ee93ecae4461c93daf11a195a6100808a15bf57b10bd7ba7241e0907d0b9.jpeg",
    "https://cdn.faire.com/fastly/6f034288c06aae1900a8c0aaf91bb2f6c1aeec49104796ebca3133c2a27b6732.jpeg",
    "https://cdn.faire.com/fastly/0b2b5f7170754ccec4d151a4e0a6b41d6a1445f93d28ef57fb560fc559f1cedc.jpeg",
  ],
  priceDollars: 5.54,
  description:
    'These beautiful crystal animal faces form an ideal visual meditation practice. Genuine gemstone cat face, hand-carved in Brazil.  0.50-1" in size.\nDue to the nature of the stone and hand carving, the sizes may vary.',
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:34.116Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
